<div *ngIf="entsprichtWohnanschriftLabel !== ''" class="mb-3x">
  <common-ui-entsprichtWohnanschrift
          [data]="entsprichtWohnanschrift"
          (dataChange)="onEntsprichtWohnanschriftClick($event)"
          [entsprichtWohnanschriftLabel]="entsprichtWohnanschriftLabel"
  >
  </common-ui-entsprichtWohnanschrift>
</div>

<div *ngIf="(!singleMode && !showInlandsAdresse && !showAuslandsAdresse && !noAddressRequired) && !this.entsprichtWohnanschrift?.entsprichtWohnanschrift"
     class="col-sm-12 col-lg-12 p-0 mb-5x">
  <common-ui-card
    [message]="'COMMON_UI.VALIDATION.KEINE_ADRESSE_ERFASST' | translate"
    type="danger">
  </common-ui-card>
</div>
<div *ngIf="(!noAddressRequired && singleMode && (!showInlandsAdresse && !showAuslandsAdresse)) && !this.entsprichtWohnanschrift?.entsprichtWohnanschrift"
     class="col-sm-12 col-lg-12 p-0 mb-5x">
  <common-ui-card
    [message]="'COMMON_UI.VALIDATION.MEHRERE_ADRESSEN_ERFASST' | translate"
    type="danger">
  </common-ui-card>
</div>
<div *ngIf="singleMode && (showInlandsAdresse && showAuslandsAdresse)" class="col-sm-12 col-lg-12 p-0 mb-5x">
  <common-ui-card
    [message]="'COMMON_UI.VALIDATION.MEHRERE_ADRESSEN_ERFASST' | translate"
    type="danger">
  </common-ui-card>
</div>

<div *ngIf="!this.entsprichtWohnanschrift?.entsprichtWohnanschrift">
<div class="mb-3x">
  <div *ngIf="!disableAuslandsadresse || !disablePostfachadresse || optionalInlandsadresse"
       class="d-flex justify-content-between mt-3x mb-3x">
    <div class="form-row">
      <div class="col-sm-12 col-lg-12 d-flex common-ui-switch-parent">
        <common-ui-switch
                (checkedChange)="showInlandsadresseChange.emit($event)"
                [(checked)]="showInlandsAdresse"
                [readonly]="readonly">
        </common-ui-switch>
        <h5>{{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.TITEL' | translate }}</h5>
      </div>
    </div>
    <common-ui-daten-uebernahme
            (picked)="inlandsadresseChange.emit($event); showInlandsAdresse=true"
            [itemTemplate]="datenuebernahmeInlandsadresse"
            [items]="stammdatenInlandsadresse" [readonly]="readonly"
            context="Inlandsadresse">
    </common-ui-daten-uebernahme>
  </div>
  <common-ui-inlandsadresse
          [showInlandsAdresse]="showInlandsAdresse"
          [inlandOrtLocalzation]="inlandOrtLocalzation"
          [inlandRequiredStrasse]="inlandRequiredStrasse"
          [inlandRequiredHausnumer]="inlandRequiredHausnumer"
          (dataChange)="inlandsadresseChange.emit($event)"
          [data]="inlandsadresse"
          [readonly]="readonly"
          [index]="index">
  </common-ui-inlandsadresse>
</div>
<div *ngIf="!disableAuslandsadresse" class="mb-3x">
  <div class="d-flex justify-content-between mb-3x">
    <div class="form-row">
      <div class="col-sm-12 col-lg-12 d-flex common-ui-switch-parent">
        <common-ui-switch
                [(checked)]="showAuslandsAdresse"
                [readonly]="readonly">
        </common-ui-switch>
        <h5>{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.TITEL' | translate }}</h5>
      </div>
    </div>
    <common-ui-daten-uebernahme
            (picked)="auslandsadresseChange.emit($event); showAuslandsAdresse = true"
            [itemTemplate]="datenuebernahmeAuslandsadresse"
            [items]="stammdatenAuslandsAdresse" [readonly]="readonly"
            context="Auslandsadresse">
    </common-ui-daten-uebernahme>
  </div>
  <common-ui-auslandsadresse
          [showAuslandsAdresse]="showAuslandsAdresse"
          (dataChange)="auslandsadresseChange.emit($event)"
          [auslandRequiredStrasse]="auslandRequiredStrasse"
          [auslandRequiredHausnumer]="auslandRequiredHausnumer"
          [data]="auslandsadresse"
          [readonly]="readonly"
          [index]="index">
  </common-ui-auslandsadresse>
</div>
<div *ngIf="!disablePostfachadresse" class="mb-3x">
  <div class="d-flex justify-content-between mb-3x">
    <div class="form-row">
      <div class="col-sm-12 col-lg-12 d-flex common-ui-switch-parent">
        <common-ui-switch
                [(checked)]="showPostfachAdresse"
                [readonly]="readonly">
        </common-ui-switch>
        <h5>{{ 'COMMON_UI.ADRESSEN.POSTFACHADRESSE.TITEL' | translate }}</h5>
      </div>
    </div>
    <common-ui-daten-uebernahme
            (picked)="postfachadresseChange.emit($event); showPostfachAdresse = true"
            [itemTemplate]="datenuebernahmePostfachadresse"
            [items]="stammdatenPostfachadresse" [readonly]="readonly"
            context="Postfachadresse"
    ></common-ui-daten-uebernahme>
  </div>
  <common-ui-postfachadresse
          [showPostfachAdresse]="showPostfachAdresse"
          (dataChange)="postfachadresseChange.emit($event)"
          [data]="postfachadresse"
          [readonly]="readonly"
          [index]="index">
  </common-ui-postfachadresse>
</div>
<div *ngIf="enableGrossempfaengeradresse">
  <div class="d-flex justify-content-between mt-3x mb-3x">
    <div class="form-row">
      <div class="col-sm-12 col-lg-12 d-flex common-ui-switch-parent">
        <common-ui-switch
                [(checked)]="showGrossempfaengerAdresse"
                [readonly]="readonly">
        </common-ui-switch>
        <h5>{{ 'COMMON_UI.ADRESSEN.GROSSEMPFAENGERADRESSE.TITEL' | translate }}</h5>
      </div>
    </div>
    <common-ui-daten-uebernahme
            (picked)="grossempfaengeradresseChange.emit($event); showGrossempfaengerAdresse = true"
            [itemTemplate]="datenuebernahmeGrossempfaengeradresse"
            [items]="stammdatenGrossempfaengeradresse"
            [readonly]="readonly"
            context="GrossempfaengerAdresse">
    </common-ui-daten-uebernahme>
  </div>
  <common-ui-grossempfaengeradresse
          [showGrossempfaengerAdresse]="showGrossempfaengerAdresse"
          (dataChange)="grossempfaengeradresseChange.emit($event)"
          [data]="grossempfaengeradresse"
          [readonly]="readonly"
          [index]="index">
  </common-ui-grossempfaengeradresse>
</div>
</div>

<ng-template #datenuebernahmeInlandsadresse let-item="item">
  <h4 class="list-group-item-heading">{{ 'COMMON_UI.ADRESSEN.INLANDSADRESSE.TITEL' | translate }}</h4>
  <p class="list-group-item-text">
    {{item?.strasse}} {{item?.hausnummer}} {{item?.hausnummernzusatz}}
    <br *ngIf="item?.adressergaenzung">{{item?.adressergaenzung}}
    <br>{{item?.postleitzahl}} {{item?.ort}}</p>
</ng-template>
<ng-template #datenuebernahmeAuslandsadresse let-item="item">
  <h4 class="list-group-item-heading">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.TITEL' | translate }}</h4>
  <p class="list-group-item-text">
    {{item?.strasse}} {{item?.hausnummer}} {{item?.hausnummernzusatz}}
    <br *ngIf="item?.adressergaenzung">{{item?.adressergaenzung}}
    <br>{{item?.postleitzahl}} {{item?.ort}}
    <span
      *ngIf="item?.land"><br>{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.LAND.KEY_' + item.land | translate }}</span>
  </p>
</ng-template>
<ng-template #datenuebernahmePostfachadresse let-item="item">
  <h4 class="list-group-item-heading">{{ 'COMMON_UI.ADRESSEN.POSTFACHADRESSE.TITEL' | translate }}</h4>
  <p class="list-group-item-text">
    {{item?.postfach}}
    <br>{{item?.postleitzahl}} {{item?.ort}}</p>
</ng-template>
<ng-template #datenuebernahmeGrossempfaengeradresse let-item="item">
  <h4 class="list-group-item-heading">{{ 'COMMON_UI.ADRESSEN.GROSSEMPFAENGERADRESSE.TITEL' | translate }}</h4>
  <p class="list-group-item-text">
    {{item?.postleitzahl}} {{item?.ort}}</p>
</ng-template>
